module.exports = __webpack_public_path__ + "static/media/flap_pockets.76f0a192.svg";